export default __webpack_public_path__ + "static/media/gallery-wip-pommel_05.85862a11.jpg";